import PropTypes from 'prop-types';
import React from 'react';
import CartItemMembershipLayout from './CartItemMembershipLayout';
import CartItemMembershipProvider from './CartItemMembershipProvider';
import lineItemPropTypes from '@react/propTypes/lineItemPropTypes';

const CartItemMembership = ({ membershipDataForMember, onComponentLoaded = () => {} }) => {
    return (
        <CartItemMembershipProvider membershipDataForMember={membershipDataForMember}>
            <CartItemMembershipLayout onComponentLoaded={onComponentLoaded} />
        </CartItemMembershipProvider>
    );
};

CartItemMembership.propTypes = {
    membershipDataForMember: PropTypes.shape({
        membership: lineItemPropTypes,
    }),
    onComponentLoaded: PropTypes.func,
};

export default CartItemMembership;
